import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import { EquipmentType } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ContainerMobile, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { HeaderWithLogout } from '../components/Header/HeaderWithLogout'
import { JobList } from '../components/JobList/JobList'
import { JobsFilter } from '../components/JobsFilter/JobsFilter'
import { JobSearchContent } from '../components/Search/JobSearchContent'

export const EquipmentOperatorJobListContainer = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const navigate = useNavigate()
  const { page } = useParams()
  const { equipmentOperatorLandingUIStore } = useOperationsStore()

  const { equipmentOperatorUIStore, equipmentOperatorSearchUIStore } = useOperationsStore()
  useEffect(() => {
    if (equipmentOperatorLandingUIStore.selectedEquipmentId === undefined) {
      navigate(`${PATHS.operators.operator.url}/${page}`)
    }
  }, [equipmentOperatorLandingUIStore.selectedEquipmentId])

  return (
    <>
      <HeaderWithLogout
        title={[
          equipmentOperatorUIStore.equipment?.name,
          equipmentOperatorUIStore.equipmentOperatorLandingUIStore.selectedGang?.name,
        ]
          .filter(Boolean)
          .join(' - ')}
        subtitle={equipmentOperatorUIStore.subtitle}
        showCorrectPosition
        showSelectEquipment
      />
      <ContainerMobile
        sx={{
          paddingY: theme.customSpacing.m,
          backgroundColor: theme.palette.grey[200],
          minHeight: 'calc(100vh - 65px)',
        }}
      >
        <Stack gap={theme.customSpacing.m}>
          <Stack flexDirection='row' alignItems='center' justifyContent='space-between'>
            <Typography variant='subtitle1'>
              {t('workInstructions', 'Work instructions')}
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={equipmentOperatorUIStore.isFullView}
                  onChange={(_, checked) => {
                    equipmentOperatorUIStore.setFullView(checked)
                  }}
                />
              }
              label={t('fullView', 'Full view')}
            />
          </Stack>

          {equipmentOperatorUIStore.typeOfSelectedEquipment !== EquipmentType.Tt && (
            <JobSearchContent />
          )}

          <JobsFilter store={equipmentOperatorUIStore} />

          <JobList
            jobGroups={equipmentOperatorUIStore.filteredJobs}
            highlightText={equipmentOperatorSearchUIStore.searchText}
          />

          {equipmentOperatorUIStore.selectedEquipmentId &&
            equipmentOperatorUIStore.filteredJobs.length === 0 && (
              <Box
                sx={{
                  height: '50vh',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='subtitle1' color='secondary'>
                  {t('noWorkAssignmentsToDisplay', 'No work assignments to display at this time')}
                </Typography>
                <Typography variant='subtitle1' color='secondary'>
                  {t('pleaseSearchForDifferentCriteria', 'Please search for different criteria')}
                </Typography>
              </Box>
            )}
        </Stack>
      </ContainerMobile>
    </>
  )
})
